// eslint-disable-next-line no-restricted-imports -- Keep this until we fully migrate to v6
import {useParams as useParamsV5} from "react-router-dom";
import {
    useParams as useParamsV6,
    type Params,
} from "react-router-dom-v5-compat";

/**
 * A safe version of useParamsV5 that will never throw an exception.
 *
 * We need this as if we attempt to access useParams while inside v6,
 * using a data router, this will throw an exception.
 *
 * @returns The params from the current route.
 */
const useProtectedV5UseParams = () => {
    try {
        return useParamsV5();
    } catch (error) {
        return {};
    }
};

/**
 * Use params from the current route.
 *
 * This is a wrapper around the useParams hook that works with both v5 and v6.
 *
 * @returns The params from the current route.
 */
export const useParams = (): Readonly<Params<string>> => {
    const v6Params = useParamsV6();
    const v5Params = useProtectedV5UseParams();

    return Object.keys(v6Params).length > 0 ? v6Params : v5Params;
};
